module.exports = __webpack_public_path__ + "static/media/jaymin_profile.d289b1b8.png";